import React from 'react';
export function ProductSection() {
  return <section className="py-10 md:py-14 px-5 bg-[radial-gradient(ellipse_at_top,rgba(107,0,182,0.2)_0%,transparent_60%),var(--dark-bg)]" data-id="element-223">
      <div className="max-w-[900px] mx-auto" data-id="element-224">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-4" data-id="element-225">
          El método
        </span>

        <h2 className="text-[clamp(1.8rem,4vw,2.8rem)] font-heading font-black leading-[1.2] mb-5" data-id="element-226">
          La colección que
          <br data-id="element-227" />
          <span className="text-gradient-magenta" data-id="element-228">va a la raíz</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-[1fr_1.2fr] gap-8 md:gap-10 items-center mt-6" data-id="element-229">
          <div className="w-full" data-id="element-230">
            <img src="https://cdn.magicpatterns.com/uploads/pJZQQ1y91fqaN7VirMLzzV/oDiXxM0087776.webp" alt="Colección Placer, Culpa y Vacío — 4 volúmenes" className="w-full rounded-2xl drop-shadow-[0_20px_50px_rgba(194,0,111,0.4)]" data-id="element-231" />
          </div>

          <div data-id="element-232">
            <h3 className="text-[clamp(1.5rem,3vw,2.2rem)] font-heading font-black mb-[10px] bg-clip-text text-transparent bg-gradient-to-br from-white to-off-white" data-id="element-233">
              PLACER, CULPA Y VACÍO
            </h3>
            <p className="text-[0.9rem] text-magenta-bright font-heading font-semibold mb-5" data-id="element-234"></p>

            <div className="flex gap-[10px] my-[25px] flex-wrap" data-id="element-235">
              <span className="bg-gradient-to-br from-purple-mid to-magenta py-2 px-[18px] rounded-full font-heading font-bold text-[0.85rem]" data-id="element-236">
                📘 Volumen 1
              </span>
              <span className="bg-gradient-to-br from-purple-mid to-magenta py-2 px-[18px] rounded-full font-heading font-bold text-[0.85rem]" data-id="element-237">
                📗 Volumen 2
              </span>
              <span className="bg-gradient-to-br from-purple-mid to-magenta py-2 px-[18px] rounded-full font-heading font-bold text-[0.85rem]" data-id="element-238">
                📙 Volumen 3
              </span>
              <span className="bg-gradient-to-br from-purple-mid to-magenta py-2 px-[18px] rounded-full font-heading font-bold text-[0.85rem]" data-id="element-239">
                📕 Volumen 4
              </span>
            </div>

            <div className="text-[1rem] leading-[1.8] text-white/80 space-y-[15px]" data-id="element-240">
              <p data-id="element-241">
                Una colección de 4 volúmenes diseñada como sistema progresivo:
                cada uno profundiza en un punto del ciclo P-C-V y te da las
                herramientas específicas para trabajarlo.
              </p>
              <p data-id="element-242">
                No es un libro para leer y guardar. Es un sistema para{' '}
                <strong data-id="element-243">hacer</strong> — con prácticas de 5 a 15 minutos diarios
                que no requieren que nadie más lo sepa.
              </p>
              <p data-id="element-244">
                Empiezas desde donde estás.{' '}
                <strong className="text-magenta-bright" data-id="element-245">Hoy.</strong>
              </p>
            </div>

            <div className="mt-8 p-5 rounded-2xl bg-gradient-to-br from-[rgba(194,0,111,0.1)] to-[rgba(107,0,182,0.1)] border border-magenta-bright/30" data-id="element-246">
              <p className="font-heading font-black text-[1.1rem] text-gold mb-1 uppercase tracking-[1px]" data-id="element-247">
                🎁 Vienen de regalo 3 bonos
              </p>
              <p className="text-[0.85rem] text-magenta-bright font-heading font-bold mb-4" data-id="element-248">
                Hoy con la compra — <span className="uppercase" data-id="element-249">GRATIS</span>
              </p>

              <div className="space-y-4" data-id="element-250">
                <div className="flex items-start gap-4 bg-[rgba(107,0,182,0.12)] rounded-xl p-3 border border-white/5" data-id="element-251">
                  <img src="https://cdn.magicpatterns.com/uploads/nMZ13FC2JgavAGyiiGzKCh/unnamed_(4).png" alt="Plan de 30 días: de los vicios a la disciplina" className="w-[80px] rounded-lg shrink-0 drop-shadow-[0_4px_12px_rgba(0,0,0,0.4)]" data-id="element-252" />
                  <div data-id="element-253">
                    <span className="inline-block bg-gradient-to-br from-purple-mid to-magenta text-white font-heading font-black text-[0.7rem] tracking-[1px] uppercase py-0.5 px-2 rounded mb-1.5" data-id="element-254">
                      BONO 1
                    </span>
                    <p className="font-heading font-bold text-white text-[0.95rem] leading-tight" data-id="element-255">
                      Plan de 30 días: de los vicios a la disciplina
                    </p>
                    <p className="text-white/50 text-[0.8rem] leading-relaxed mt-1" data-id="element-256">
                      Guía paso a paso con ejercicios diarios para reemplazar
                      hábitos destructivos por rutinas que fortalecen tu
                      disciplina.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4 bg-[rgba(107,0,182,0.12)] rounded-xl p-3 border border-white/5" data-id="element-257">
                  <img src="https://cdn.magicpatterns.com/uploads/aBaUcJ67RpJSyimUaQ9Px4/unnamed_(3).png" alt="Entender la dopamina y el cerebro adictivo" className="w-[80px] rounded-lg shrink-0 drop-shadow-[0_4px_12px_rgba(0,0,0,0.4)]" data-id="element-258" />
                  <div data-id="element-259">
                    <span className="inline-block bg-gradient-to-br from-purple-mid to-magenta text-white font-heading font-black text-[0.7rem] tracking-[1px] uppercase py-0.5 px-2 rounded mb-1.5" data-id="element-260">
                      BONO 2
                    </span>
                    <p className="font-heading font-bold text-white text-[0.95rem] leading-tight" data-id="element-261">
                      Entender la dopamina y el cerebro adictivo
                    </p>
                    <p className="text-white/50 text-[0.8rem] leading-relaxed mt-1" data-id="element-262">
                      Aprende cómo funciona el sistema de recompensa de tu
                      cerebro y por qué caes en patrones repetitivos.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4 bg-[rgba(107,0,182,0.12)] rounded-xl p-3 border border-white/5" data-id="element-263">
                  <img src="https://cdn.magicpatterns.com/uploads/renZEirDDVqjtt9rixQ7AY/unnamed_(2).png" alt="Cómo manejar una recaída sin destruir tu proceso" className="w-[80px] rounded-lg shrink-0 drop-shadow-[0_4px_12px_rgba(0,0,0,0.4)]" data-id="element-264" />
                  <div data-id="element-265">
                    <span className="inline-block bg-gradient-to-br from-purple-mid to-magenta text-white font-heading font-black text-[0.7rem] tracking-[1px] uppercase py-0.5 px-2 rounded mb-1.5" data-id="element-266">
                      BONO 3
                    </span>
                    <p className="font-heading font-bold text-white text-[0.95rem] leading-tight" data-id="element-267">
                      Cómo manejar una recaída sin destruir tu proceso
                    </p>
                    <p className="text-white/50 text-[0.8rem] leading-relaxed mt-1" data-id="element-268">
                      Estrategias concretas para que un tropiezo no se convierta
                      en una caída libre y puedas retomar tu camino.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}